
import { defineComponent, reactive } from 'vue'

import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import { rpp } from '@/core/realisations/rpp.realisation'

export default defineComponent({
    components: { Modal, TheInput },
    emits: ['cancel'],
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,
            from_date: null as string | null,
            to_date: null as string | null,
        })

        const state_form$ = useVuelidate({ from_date: { required }, to_date: { required } }, state)

        const emitCancel = () => {
            emit('cancel')
        }

        const saveFile = (content: File | Blob, file_name: string) => {
            const download_url = window.URL.createObjectURL(content)

            const link = document.createElement('a')
            link.href = download_url
            link.setAttribute('download', file_name)
            document.body.appendChild(link)
            link.click()
            link.remove()
        }

        const exportRPP = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            if (!state.from_date || !state.to_date) return

            try {
                state.is_loading = true

                const payload = {
                    turnover_date_from: state.from_date,
                    turnover_date_to: state.to_date,
                }

                const response = await rpp.exportLTLExcel(payload)
                saveFile(response, `LTL РПП ${state.from_date}-${state.to_date}.xlsx`)

                emitCancel()
            } catch (error) {
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        return { state, state_form$, emitCancel, exportRPP }
    },
})
